import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormSummary } from './form-summary';
import { SharedModule } from 'app/shared/shared.module';


@NgModule({
  declarations: [
    FormSummary,
  ],
  imports: [
    CommonModule,
    SharedModule,
    
  ],
  exports: [
    FormSummary
  ]
})
export class FormSummaryModule { }
